import { daysBetweenTimestamps, daysSinceTimestamp } from "@/utils/date"

// This is temp, should handled on the backend when fetchign the ads from meta.
export const removeAdsDuplicationsAndAddDaysRunningAmount = (externalAds) => {
    const unique = Object.values(
        externalAds.reduce((acc, item) => {
            if (!acc[item.collectionId] || !item.collectionId) {
                acc[item.collectionId] = item
                const amountOfDays = item.isActive ? daysSinceTimestamp(item.startDate) : daysBetweenTimestamps(item.startDate, item.endDate)
                item.amountOfDays = amountOfDays <= 0 ? 1 : amountOfDays
            }
            return acc
        }, {})
    )
    return unique
}

export const stripURL = (url) => {
    try {
        // Create a URL object
        const urlObj = new URL(url);

        // Get the hostname and pathname
        return urlObj.hostname + urlObj.pathname;
    } catch (error) {
        console.error("Invalid URL:", error.message);
        return null; // Return null for invalid URLs
    }
}


export const extractData = (adData) => {

    const defaultImg = 'https://i.seadn.io/gae/OGpebYaykwlc8Tbk-oGxtxuv8HysLYKqw-FurtYql2UBd_q_-ENAwDY82PkbNB68aTkCINn6tOhpA8pF5SAewC2auZ_44Q77PcOo870?auto=format&dpr=1&w=1000'

    let adBody = adData.body ? adData.body : ''
    let adImage = adData.originalImageUrl ? adData.originalImageUrl : (adData.videoPreviewImageUrl ?? defaultImg)
    let adVideo = adData.videoSdUrl ? adData.videoSdUrl : ''
    let ctaText = adData.ctaText ? adData.ctaText : 'Shop Now'
    let adBottomText = adData.title ? adData.title : ''
    let linkUrl = adData.linkUrl ? stripURL(adData.linkUrl) : ''
    let originalLinkUrl = adData.linkUrl

    const innerCard = adData.adCards?.[0]
    if (innerCard) {
        adBody = innerCard.body ? innerCard.body : ''
        adImage = innerCard.originalImageUrl ? innerCard.originalImageUrl : (innerCard.videoPreviewImageUrl ?? defaultImg)
        adVideo = innerCard.videoSdUrl ? innerCard.videoSdUrl : ''
        ctaText = innerCard.ctaText ? innerCard.ctaText : 'Shop Now'
        adBottomText = innerCard.title ? innerCard.title : ''
        linkUrl = innerCard.linkUrl ? stripURL(innerCard.linkUrl) : ''
        originalLinkUrl = innerCard.linkUrl
    }

    return { adBody, adImage, adVideo, ctaText, adBottomText, linkUrl, originalLinkUrl }
}

export const isVideoAd = (adData) => {
    const { adVideo } = extractData(adData)
    return !!adVideo
}
